<template>
  <div class="content">
    <div class="box">
      <div id="codeDiv" style="display: none;" ref="qrCodeUrl"></div>
      <div class="title">请使用微众银行企业金融APP</div>
      <div class="tip">扫码添加推荐人并完成申请</div>
      <div class="scanCodeBox">
        <div class="qrcode" id="qrcode"></div>
      </div>
      <div class="text">二维码有效期</div>
      <div class="time">{{ this.$route.query['end_time'] }}</div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';

export default {
  data() {
    return {
      type: '',
      picture: '',
    };
  },
  mounted() {
    const {
      code_url
    } = this.$route.query;
    this.creatQrCode(code_url);
  },
  computed: {},
  methods: {
    creatQrCode(url) {
      const qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
      console.log(qrcode);
      const canvas = document.getElementsByTagName('canvas')[0];
      const img = this.convertCanvasToImage(canvas);
      document.getElementById('qrcode').append(img);
    },
    convertCanvasToImage(canvas) {
      // 新建Image对象
      const image = new Image();
      image.style.width = '100%';
      // canvas.toDataURL 返回的是一串Base64编码的URL
      image.src = canvas.toDataURL('image/png');
      return image;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box {
  max-width: 500px;
  max-height: 800px;
  flex-direction: column;
  display: flex;
  align-items: center;
  height: calc(100vh - 32px);
  width: calc(100vw - 32px);
  justify-content: center;
  margin: 16px;
  background: url("~@/assets/images/scanCodeWZ_background.png") no-repeat top
    left;
  background-color: #fff;
  background-size: contain;
  border-radius: 16px;
  .title {
    font-size: 20px;
    color: #367ee8;
    text-align: center;
    font-weight: 600;
    text-align: center;
    margin-bottom: 6px;
  }
  .tip {
    font-size: 14px;
    color: #46494d;
    text-align: center;
    font-weight: 400;
    margin-bottom: 30px;
  }
  .scanCodeBox {
    width: 216px;
    height: 216px;
    background: url("~@/assets/images/scanCodeWZ_border.jpg") center center;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    .qrcode {
      width: 180px;
      height: 180px;
    }
  }
  .text {
    margin-top: 20px;
    font-size: 12px;
    color: #767980;
    text-align: center;
    font-weight: 400;
    margin-bottom: 4px;
  }
  .time {
    font-size: 16px;
    color: #e83636;
    text-align: center;
    font-weight: 600;
  }
}
</style>
